/* ChatHistory.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0rIjyk2ADO%7Bmargin-block-end%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U2ADO%7Bpadding-block%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E2ADO%7Bpadding-inline-start%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
import React, { useCallback, useMemo, useState } from 'react';
import IconButton from '@atlaskit/button/icon/button';
import AddIcon from '@atlaskit/icon/core/add';
import FolderAddIcon from '@atlaskit/icon-lab/core/folder-add';
import HistoryIcon from '@atlaskit/icon-lab/core/history';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { usePublish, useSubscribe } from '@atlaskit/rovo-triggers';
import { ExpandableMenuItem, ExpandableMenuItemTrigger, ExpandableMenuItemContent } from '@atlaskit/side-nav-items/expandable-menu-item';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuSection, MenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { useRovoNavigation, SideNavProvider, useSmartCreationChatStoreApi } from '@atlassian/conversation-assistant';
import ConversationAssistant from '@atlassian/conversation-assistant';
import { Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';
import { DeleteConversationModal } from '@atlassian/conversation-assistant-ui-components';
import { ChatListMenuItems } from '@atlassian/rovo-navigation/chat-list-items';
import { SpaceMenuItems } from '@atlassian/rovo-navigation/space-items';
import { useSpaceStoreActions } from '@atlassian/rovo-spaces/controllers/space-store';
import { CreateSpaceModal } from '@atlassian/rovo-spaces/ui/CreateSpaceModal';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
import { useTownsquareApp } from '@townsquare/app-context';
import { isInRovoFullscreenPages } from '@townsquare/chat-view/__router-route';
import { DividerCompiled } from '@townsquare/divider';
import { getEmojiProviderForCloudId } from '@townsquare/emoji-provider';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { Link } from '@townsquare/router/primitives/link';
import { useRouter } from '@townsquare/router/useRouter';
import { chatRoute } from '@townsquare/routes/chat';
import { sharedConversationPreviewRoute } from '@townsquare/routes/shared-conversation-preview';
import { useAssistanceServiceParams, useRovoParams, useRovoProductHeader } from '@townsquare/rovo/hooks';
import { expVal } from '@townsquare/stat-sig';
import { ROVO_CHAT_SPACES_EXPERIMENT } from '@townsquare/stat-sig/experiments';
import { fg } from '@townsquare/stat-sig/gate';
import { useUserStore } from '@townsquare/user-store';
import { ChatHistorySkeleton } from './ChatHistorySkeleton';
const MAX_CONVERSATIONS = 20;
const styles = {
  container: "_0rIjyk2ADO",
  heading: "_4c065U2ADO _0LQT5E2ADO _1UtDYzZpcK"
};
type ConversationAssistantInitProps = {
  cloudId: string;
  userId: string | undefined;
};
const EMPTY_CONVO_ID = 'EMPTY_CONVERSATION_ID';
/**
 * Initialises Conversation Assistant to ensure chat store and other state is initialised.
 */
const ConversationAssistantInit = ({
  cloudId,
  userId
}: ConversationAssistantInitProps) => {
  const app = useTownsquareApp();
  const product = useRovoProductHeader();
  const config = useMemo(() => ({
    product,
    siteId: cloudId,
    userId,
    xpcProduct: 'townsquare',
    xpcSubProduct: `townsquare-${app}`,
    assistanceServiceConfig: {
      headers: {
        'X-Cloudid': cloudId
      },
      baseUrl: '/gateway/api/assist'
    }
  }), [cloudId, userId, app, product]);
  return <VisuallyHidden>
			{/* overridingChildren is required so that only state is initialised. This prevents duplicate listeners from being added. */}
			<ConversationAssistant config={config} overridingChildren={<></>} />
		</VisuallyHidden>;
};
const ChatList = ({
  onCreateSpaceClick
}: {
  onCreateSpaceClick: () => void;
}) => {
  const {
    cloudId
  } = useRovoParams();
  const publish = usePublish('ai-mate');
  const {
    addSpace
  } = useSpaceStoreActions();
  const assistanceServiceParams = useAssistanceServiceParams({
    experienceId: 'ai-mate',
    touchpointSource: 'townsquare-sidenav'
  });
  const {
    conversations,
    pinnedCountConversations,
    pinnedConversationSummary,
    currentConversation,
    handleConversationClick,
    handleViewAllConversationsClick,
    handleViewAllSpacesClick,
    handleConversationPinToggle,
    editConversation: {
      handleEditConversationConfirm
    },
    deleteConversation: {
      openDeleteModal,
      conversationToBeDeleted,
      handleDeleteConfirm
    },
    moveToSpace: {
      handleMoveConversationToSpace,
      handleMoveConversationToNewSpace,
      conversationToMoveToNewSpace,
      clearConversationToMoveToNewSpace
    },
    isConversationsInitialized
  } = useRovoNavigation({
    assistanceServiceParams,
    isTasksEnabled: fg('rovo_chat_enable_tasks'),
    conversationLimit: MAX_CONVERSATIONS
  });
  const {
    pushTo
  } = useRouterActions();
  const [routerState] = useRouter();
  // The shared preview renders someone else's conversation, so the viewer's own current
  // conversation must not be highlighted in the sidebar lists while it is open.
  const shouldHighlightCurrentConversation = isInRovoFullscreenPages(routerState.route.name) && routerState.route.name !== sharedConversationPreviewRoute.name;
  const {
    setSelectedConversation
  } = useSmartCreationChatStoreApi();
  const onSelectConversation = useCallback((conversation: Conversation, isADSNavigationEnabled: boolean) => {
    pushTo(chatRoute, {
      query: {
        rovoChatPathway: 'chat',
        rovoChatConversationId: conversation.id
      }
    });
    handleConversationClick(conversation, isADSNavigationEnabled);
  }, [pushTo, handleConversationClick]);
  const onViewAllConversations = useCallback(() => {
    pushTo(chatRoute, {
      query: {
        rovoChatPathway: 'chat'
      }
    });
    handleViewAllConversationsClick();
    setSelectedConversation({
      conversationId: ''
    });
  }, [pushTo, handleViewAllConversationsClick, setSelectedConversation]);
  const onViewAllSpacesClick = useCallback(() => {
    pushTo(chatRoute, {
      query: {
        rovoChatPathway: 'chat'
      }
    });
    publish({
      type: 'space-deselected',
      source: 'rovo-sidebar-navigation'
    });
    handleViewAllSpacesClick();
  }, [pushTo, publish, handleViewAllSpacesClick]);

  // Track which space (or the recommended-spaces panel) is currently selected
  // so we can highlight the correct nav item. We mirror the truth held in
  // `ChatView` by listening to the same `ai-mate` events that drive its state.
  const [selectedSpaceId, setSelectedSpaceId] = useState<string | undefined>(undefined);
  const [isRecommendedSpacesSelected, setIsRecommendedSpacesSelected] = useState(false);
  useSubscribe({
    topic: 'ai-mate'
  }, event => {
    if (event.type === 'space-selected') {
      setSelectedSpaceId(event.data.spaceId);
      setIsRecommendedSpacesSelected(false);
    } else if (event.type === 'space-deselected' || event.type === 'chat-new') {
      setSelectedSpaceId(undefined);
      setIsRecommendedSpacesSelected(false);
      if (event.type === 'chat-new') {
        setConversationLocation('loose');
      }
    } else if (event.type === 'recommended-spaces-selected') {
      setSelectedSpaceId(undefined);
      setIsRecommendedSpacesSelected(true);
    }
  });

  // When the user picks any conversation (either inside a space or in the
  // loose list), we want to drop the space-level highlight so only the
  // conversation row is shown as selected. There's no dedicated event for
  // conversation selection, so we clear the local state directly from the
  // click handlers below.
  const clearSpaceHighlight = useCallback(() => {
    setSelectedSpaceId(undefined);
    setIsRecommendedSpacesSelected(false);
  }, []);

  // Track WHERE the currently-selected conversation lives so we pass
  // `currentConversation` to exactly one list. Without this, a conversation
  // appearing in both the per-space API result AND the loose chat-store list
  // (same id, both with `rovoSpaceId: null`) would highlight in two places.
  //
  // 'loose' → show in ChatListMenuItems only
  // 'space' → show in SpaceMenuItems only
  // null (initial page-load) → default to 'loose'
  const [conversationLocation, setConversationLocation] = useState<'loose' | 'space' | null>(null);
  const effectiveLocation = conversationLocation ?? 'loose';
  const conversationForLooseList = shouldHighlightCurrentConversation && !selectedSpaceId && !isRecommendedSpacesSelected && effectiveLocation === 'loose' ? currentConversation : undefined;
  const conversationForSpaceList = shouldHighlightCurrentConversation && !selectedSpaceId && !isRecommendedSpacesSelected && effectiveLocation === 'space' ? currentConversation : undefined;

  // Waiting for conversations to be initialized
  if (!isConversationsInitialized) {
    return <ChatHistorySkeleton />;
  }
  const hasNoConversations = conversations.length < 1 || conversations.length === 1 && conversations[0].id === EMPTY_CONVO_ID;
  const isSpacesEnabled = expVal(ROVO_CHAT_SPACES_EXPERIMENT, 'isEnabled', false);
  const isPinnedChatsEnabled = fg('rovo_chat_pinned_fe');
  const chatListContent = hasNoConversations ? <Inline space="space.100" alignBlock="center" spread="space-between" xcss={styles.heading} role="listitem">
			<Text size="medium" weight="medium" color="color.text.subtle">
				<FormattedMessage id="townsquare.rovo-side-nav.chat-history.empty-state-title" defaultMessage="Nothing here yet. <a>Start a chat with Rovo</a>." description="Title for the chat history section in the side navigation when there are no chats" values={{
        a: chunks => <Link to={chatRoute}>{chunks}</Link>
      }} />
			</Text>
		</Inline> : <ChatListMenuItems conversations={conversations} pinnedCountConversations={pinnedCountConversations} pinnedConversationSummary={pinnedConversationSummary}
  // When a space or the recommended-spaces panel is selected, clear the
  // "current conversation" highlight in the standalone list so only the
  // space / recommended-spaces nav item appears selected. Mirrors the
  // behaviour of the platform `SideNavigation` component.
  currentConversation={conversationForLooseList} onSelectConversation={(conversation, isADSNavigationEnabled) => {
    clearSpaceHighlight();
    setConversationLocation('loose');
    publish({
      type: 'space-deselected',
      source: 'rovo-sidebar-navigation'
    });
    onSelectConversation(conversation, isADSNavigationEnabled);
  }} onConversationDelete={openDeleteModal} onConversationRename={handleEditConversationConfirm} onConversationPinToggle={isPinnedChatsEnabled ? handleConversationPinToggle : undefined} onViewAllConversations={onViewAllConversations} onConversationMoveToSpace={handleMoveConversationToSpace} onConversationMoveToNewSpace={handleMoveConversationToNewSpace} isADSNavigationEnabled={true} isNewAllConversationScreenEnabled={fg('rovo_chat_chat_history_refresh')} cloudId={cloudId} />;
  return <>
			{isSpacesEnabled && <MenuSection isMenuListItem>
					<Inline alignBlock="center" spread="space-between">
						<MenuSectionHeading>
							<FormattedMessage id="townsquare.rovo-side-nav.chat-history.spaces-subsection-title" defaultMessage="Spaces" description="Title for the Spaces subsection in the Rovo side navigation chat history section" />
						</MenuSectionHeading>
						<CreateSpaceButton onClick={onCreateSpaceClick} />
					</Inline>
					<MenuList>
						<SpaceMenuItems conversations={conversations} pinnedConversationSummary={pinnedConversationSummary}
        // When a space (or the recommended-spaces panel) is selected at the
        // space level, no individual conversation should appear as the
        // "current" one. Once the user picks a conversation inside a space,
        // `selectedSpaceId` is cleared and the conversation row becomes the
        // only highlighted item.
        currentConversation={conversationForSpaceList} onSelectConversation={(conversation, isADSNavigationEnabled) => {
          clearSpaceHighlight();
          setConversationLocation('space');
          publish({
            type: 'space-deselected',
            source: 'rovo-sidebar-navigation'
          });
          onSelectConversation(conversation, isADSNavigationEnabled);
        }} onConversationDelete={openDeleteModal} onConversationRename={handleEditConversationConfirm} onConversationPinToggle={isPinnedChatsEnabled ? handleConversationPinToggle : undefined} onSelectSpace={space => {
          pushTo(chatRoute, {
            query: {
              rovoChatPathway: 'chat'
            }
          });
          publish({
            type: 'space-selected',
            source: 'rovo-sidebar-navigation',
            data: {
              spaceId: space.id,
              title: space.name,
              emoji: space.emoji ?? '',
              description: space.description ?? undefined,
              entryPoint: 'leftNav'
            }
          });
        }} onSelectRecommendedSpaces={() => {
          pushTo(chatRoute, {
            query: {
              rovoChatPathway: 'chat'
            }
          });
          publish({
            type: 'recommended-spaces-selected',
            source: 'rovo-sidebar-navigation'
          });
        }} selectedSpaceId={selectedSpaceId} isRecommendedSpacesSelected={isRecommendedSpacesSelected} isADSNavigationEnabled={true} isNewAllConversationScreenEnabled={fg('rovo_chat_chat_history_refresh')} onViewAllSpacesClick={onViewAllSpacesClick} cloudId={cloudId} product={assistanceServiceParams.product} experienceId="ai-mate" />
					</MenuList>
				</MenuSection>}
			{isSpacesEnabled ? <MenuSection isMenuListItem>
					<MenuSectionHeading>
						<FormattedMessage id="townsquare.rovo-side-nav.chat-history.chats-subsection-title" defaultMessage="Chats" description="Title for the Chats subsection in the Rovo side navigation chat history section" />
					</MenuSectionHeading>
					<MenuList>{chatListContent}</MenuList>
				</MenuSection> : chatListContent}
			{conversationToBeDeleted && <DeleteConversationModal onDeleteConfirm={() => handleDeleteConfirm(conversationToBeDeleted.id)} />}
			{conversationToMoveToNewSpace && <CreateSpaceModal isOpen={true} onClose={clearConversationToMoveToNewSpace} cloudId={cloudId} initialConversationId={conversationToMoveToNewSpace.id} onCreated={(response, emojiId) => {
      addSpace(response, emojiId);
      clearConversationToMoveToNewSpace();
    }} />}
		</>;
};
const NewChatButton = () => {
  const intl = useIntl();
  const publish = usePublish('ai-mate');
  const assistanceServiceParams = useAssistanceServiceParams({
    experienceId: 'ai-mate',
    touchpointSource: 'townsquare-sidenav'
  });
  const {
    handleNewChatClick
  } = useRovoNavigation({
    assistanceServiceParams
  });
  const {
    pushTo
  } = useRouterActions();
  const onNewChatClick = useCallback(() => {
    pushTo(chatRoute, {
      query: {
        rovoChatPathway: 'chat'
      }
    });
    handleNewChatClick(true);
  }, [handleNewChatClick, pushTo]);
  return <IconButton icon={AddIcon} label={intl.formatMessage({
    id: 'townsquare.rovo-side-nav.chat-history.new-chat-button-label',
    defaultMessage: 'New chat',
    description: 'Label for the new chat button in the chat history section in the side navigation'
  })} onClick={() => {
    publish({
      type: 'space-deselected',
      source: 'rovo-sidebar-navigation'
    });
    onNewChatClick();
  }} appearance="subtle" spacing="compact" isTooltipDisabled={false} />;
};
const CreateSpaceButton = ({
  onClick
}: {
  onClick: () => void;
}) => {
  const intl = useIntl();
  return <IconButton testId="rovo-chat-sidenav-spaces-create-space" icon={FolderAddIcon} label={intl.formatMessage({
    id: 'townsquare.rovo-side-nav.chat-history.create-space-button-label',
    defaultMessage: 'Create space',
    description: 'Label for the create space button in the chat history section in the side navigation'
  })} onClick={onClick} appearance="subtle" spacing="compact" isTooltipDisabled={false} />;
};
const ChatHistoryActions = () => {
  return <Inline alignBlock="center" space="space.050">
			<NewChatButton />
		</Inline>;
};
const ChatHistoryExpandable = ({
  isDefaultExpanded,
  onCreateSpaceClick
}: {
  isDefaultExpanded?: boolean;
  onCreateSpaceClick: () => void;
}) => {
  const analytics = useAnalytics();
  const [routerState] = useRouter();
  const onExpansionToggle = useCallback((isExpanded: boolean) => {
    void analytics.ui('rovoAppChatHistorySection', 'toggled', {
      toggleAction: isExpanded ? 'expanded' : 'collapsed',
      screen: routerState.route.name
    });
  }, [analytics, routerState.route.name]);
  return <ExpandableMenuItem isDefaultExpanded={isDefaultExpanded} onExpansionToggle={onExpansionToggle}>
			<ExpandableMenuItemTrigger elemBefore={<HistoryIcon label="" color="currentColor" />} actions={<ChatHistoryActions />}>
				<FormattedMessage id="townsquare.rovo-side-nav.chat-history.title" defaultMessage="Your chats" description="Title for the chat history section in the side navigation" />
			</ExpandableMenuItemTrigger>
			{/* ExpandableMenuItemContent has a role of List, so the children need to be role='listitem' */}
			<ExpandableMenuItemContent>
				<ChatList onCreateSpaceClick={onCreateSpaceClick} />
			</ExpandableMenuItemContent>
		</ExpandableMenuItem>;
};
const ChatHistoryInner = ({
  isDefaultExpanded,
  cloudId,
  userId
}: {
  isDefaultExpanded: boolean;
  cloudId: string;
  userId: string | undefined;
}) => {
  const [isCreateSpaceModalOpen, setIsCreateSpaceModalOpen] = useState(false);
  const {
    addSpace
  } = useSpaceStoreActions();
  const publish = usePublish('ai-mate');
  const {
    pushTo
  } = useRouterActions();
  const isSpacesEnabled = expVal(ROVO_CHAT_SPACES_EXPERIMENT, 'isEnabled', false);
  const emojiProvider = useMemo(() => cloudId && userId ? getEmojiProviderForCloudId(cloudId, userId) : undefined, [cloudId, userId]);
  const onCreateSpaceClick = useCallback(() => {
    setIsCreateSpaceModalOpen(true);
  }, []);
  return <>
			<Stack space="space.100" xcss={styles.container}>
				<DividerCompiled margin="0px -12px" height="1px" />
				<MenuList>
					<ChatHistoryExpandable isDefaultExpanded={isDefaultExpanded} key={isDefaultExpanded ? 'expanded' : 'collapsed'} // This is to force re-render when the route changes
        onCreateSpaceClick={onCreateSpaceClick} />
				</MenuList>
				<DividerCompiled margin="0px -12px" height="1px" />
			</Stack>
			{isSpacesEnabled && isCreateSpaceModalOpen && <CreateSpaceModal isOpen={true} onClose={() => setIsCreateSpaceModalOpen(false)} cloudId={cloudId} emojiProvider={emojiProvider} onCreated={(response, emojiId) => {
      addSpace(response, emojiId);
      setIsCreateSpaceModalOpen(false);
      pushTo(chatRoute, {
        query: {
          rovoChatPathway: 'chat'
        }
      });
      publish({
        type: 'space-selected',
        source: 'rovo-sidebar-navigation',
        data: {
          spaceId: response.id,
          title: response.name,
          emoji: emojiId ?? '',
          description: response.description ?? undefined,
          entryPoint: 'leftNav'
        }
      });
    }} />}
		</>;
};
export const ChatHistory = ({
  isDefaultExpanded = false
}: {
  isDefaultExpanded?: boolean;
}): React.ReactNode => {
  const {
    cloudId
  } = useRovoParams();
  const [currentUser] = useUserStore();
  return <SideNavProvider>
			{/* Initialise Conversation Assistant to ensure chat store and other state is initialised */}
			<ConversationAssistantInit cloudId={cloudId} userId={currentUser.accountId ?? undefined} />
			<ChatHistoryInner isDefaultExpanded={isDefaultExpanded} cloudId={cloudId} userId={currentUser.accountId ?? undefined} />
		</SideNavProvider>;
};